export enum SocialNetworks {
    None = '0',
    Facebook = 'FB',
    VKontakte = 'VK',
    Odnoklassniki = 'OK',
    Google = 'GG'
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/SocialNetworks.ts